import { createSelector } from '@ngrx/store';
import { selectRootState } from 'app/store/root/root.state';
import * as fromCouriers from './couriers.reducer';

export const rootCouriersState = createSelector(
  selectRootState,
  state => state.couriers,
);

export const rootCouriers = createSelector(
  selectRootState,
  state => fromCouriers.selectAll(state.couriers),
);
